export const quotes = [
  {
    text: "La vraie générosité envers l'avenir consiste à tout donner au présent.",
    author: "Albert Camus"
  },
  {
    text: "Il n'y a qu'un bonheur dans la vie, c'est d'aimer et d'être aimé.",
    author: "George Sand"
  },
  {
    text: "L'avenir appartient à ceux qui se lèvent tôt.",
    author: "Proverbe français"
  },
  {
    text: "La vie, c'est comme une bicyclette, il faut avancer pour ne pas perdre l'équilibre.",
    author: "Albert Einstein"
  },
  {
    text: "Il vaut mieux faire que dire, il vaut mieux être que paraître.",
    author: "Proverbe français"
  },
  {
    text: "On ne voit bien qu'avec le cœur. L'essentiel est invisible pour les yeux.",
    author: "Antoine de Saint-Exupéry"
  },
  {
    text: "Le bonheur n'est pas une destination, c'est une façon de voyager.",
    author: "Margaret Lee Runbeck"
  },
  {
    text: "Il faut toujours viser la lune, car même en cas d'échec, on atterrit dans les étoiles.",
    author: "Oscar Wilde"
  },
  {
    text: "La liberté, c'est de pouvoir choisir celui dont on sera l'esclave.",
    author: "Jeanne Moreau"
  },
  {
    text: "Ce n'est pas parce que les choses sont difficiles que nous n'osons pas, c'est parce que nous n'osons pas qu'elles sont difficiles.",
    author: "Sénèque"
  },
  {
    text: "L'imagination est plus importante que le savoir.",
    author: "Albert Einstein"
  },
  {
    text: "Tout ce qui ne nous tue pas nous rend plus fort.",
    author: "Friedrich Nietzsche"
  },
  {
    text: "Le succès c'est d'aller d'échec en échec sans perdre son enthousiasme.",
    author: "Winston Churchill"
  },
  {
    text: "La vie est un défi à relever, un bonheur à mériter, une aventure à tenter.",
    author: "Mère Teresa"
  },
  {
    text: "Il n'est jamais trop tard pour devenir ce que vous auriez pu être.",
    author: "George Eliot"
  },
  {
    text: "L'éducation est l'arme la plus puissante qu'on puisse utiliser pour changer le monde.",
    author: "Nelson Mandela"
  },
  {
    text: "La seule façon de faire du bon travail, c'est d'aimer ce que vous faites.",
    author: "Steve Jobs"
  },
  {
    text: "Hier n'est que songe, demain n'est que vision. Mais aujourd'hui bien vécu fait de chaque hier un songe de bonheur.",
    author: "Proverbe sanscrit"
  },
  {
    text: "Le courage, c'est de ne pas subir sa vie mais de la choisir.",
    author: "Jean-Paul Sartre"
  },
  {
    text: "La plus grande révolution de notre génération est la découverte que l'être humain, en changeant l'attitude de ses pensées, peut changer les aspects extérieurs de sa vie.",
    author: "William James"
  }
]